import { render, staticRenderFns } from "./formDetalleCarga.vue?vue&type=template&id=e9cc0e6e&scoped=true&"
import script from "./formDetalleCarga.vue?vue&type=script&lang=js&"
export * from "./formDetalleCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cc0e6e",
  null
  
)

export default component.exports